import { api } from './client';
import { stringifyParams } from '@/lib/utils';
import type { ApiResponse } from '@/types/api';
import type {
  User,
  UserDelete,
  Users,
  UsersUpdate
} from '@/types/user';

/**
 * 임직원 관리자 리스트 
 * @param params 
 * @returns 
 */
export async function getUsers(params: {page: number, limit: number}): Promise<ApiResponse<Users>> {
  const stringParams = stringifyParams(params);
  return api.get<Users>(`/user`, { params: stringParams });
}

/**
 * 임직원 관리자 수정 
 * @param data 수정할 임직원 리스트
 * @returns 
 */
export async function updateUsers(data: Partial<UsersUpdate>): Promise<ApiResponse<UsersUpdate>> {
  return api.put<UsersUpdate>(`/user`, { body: data });
}

/**
 * 임직원 관리자 삭제 
 * @param userIds 삭제할 임직원 관리자 ID ,로 구분하여 여러개 전송
 * @returns 
 */
export async function deleteUsers(userIds: string): Promise<ApiResponse<UserDelete>> {
  const stringParams = stringifyParams({ userIds });
  return api.delete<UserDelete>(`/user`, { params: stringParams });
}
